export default __webpack_public_path__ + "static/media/kgabo-logo.e8128598.PNG";